import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import RightLinkBar from "../HomeWidgets/RightLinkBar";
import HomeWidget from "../HomeWidgets/HomeWidget";
import JokeWidget from "../HomeWidgets/JokeWidget";
import LineGraph, { ActivityRateIncrease } from "../HomeWidgets/LineGraph";
import PieChartDisplay, { SpecialtyCount } from "../HomeWidgets/PieChart";
import { getTotalNotes, getActiveDoctors, getActiveVsTotal, getAllDoctorsCount, getAllPatientsCount, getAllPlgUsers, getAllSpecialties, renderSixMonthSpan, getAverageSummarizeTime, getRecentNotesCount, getAllOrgs, queryNotesProcessing, queryAllDoctors, getNewDoctorsThisWeek, getWeeklyDoctorUtilization } from "../../utils/functions";
import OrgSelector from "../HomeWidgets/OrgSelector";
import DoctorSelector from "../HomeWidgets/DoctorSelector";
import Utilization from "../HomeWidgets/Utilization";
import UploadToSummarizeWidget from "../HomeWidgets/UploadToSummarizeWidget";
import { isCapabilityEnabled } from "../../config/capabilities";


export default function InternalHome({ setAuth, userOrg, setUserOrg }) {
  const username = localStorage.getItem("username");

  const todaysDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const activeDoctorTimeline = renderSixMonthSpan();

  const [showJoke, setShowJoke] = useState(false);

  return (
    <div>
      <Sidebar setAuth={setAuth} setUserOrg={setUserOrg} />
      <RightLinkBar />
      <div
        className="h-dvh flex flex-col mr-[280px] text-dark-purple"
        style={{
          marginLeft: "var(--sidebar-width, 250px)",
          width: "calc(100% - var(--sidebar-width, 250px) - 280px)",
        }}
      >
        <div className="flex flex-col items ml-[15%] mt-[10%] gap-8">
          <div>
            <h1 className="font-black text-[36px] relative">Welcome back, {username}! <button onClick={(() => setShowJoke(!showJoke))}>👋</button>
              <JokeWidget showJoke={showJoke} />
            </h1>
            <h3 className="text-[20px]">{todaysDate}</h3>
          </div>
          <div className="flex flex-col gap-4">
            <h3 className="font-extrabold text-[24px]">At a Glance 🔎</h3>
            <div className="flex gap-4 flex-wrap">
              <HomeWidget displayText="Doctors" asyncFunction={getAllDoctorsCount} />
              <HomeWidget displayText="Active Doctors" asyncFunction={getActiveDoctors} />
              <UploadToSummarizeWidget />
              <HomeWidget displayText="Processing" asyncFunction={queryNotesProcessing} helperScript={"Processing"} />
              {isCapabilityEnabled("commercialDashboardMetrics") && (
                <>
                  {/* <HomeWidget displayText="PLG Users" asyncFunction={getAllPlgUsers} helperScript={"PLG Users"} /> */}
                <HomeWidget displayText="Patients" asyncFunction={getAllPatientsCount} />
                  <HomeWidget displayText="Notes" asyncFunction={getTotalNotes} />
                  <HomeWidget displayText="Summarize Time" asyncFunction={getAverageSummarizeTime} appendS={true} />
                <HomeWidget displayText="Weekly Notes" asyncFunction={getRecentNotesCount} />
                </>
              )}
              {/* <HomeWidget displayText="iOS Errors" variableProp={totalIOSErrors} /> */}
              {/* <HomeWidget displayText="Android Errors" variableProp={totalAndroidErrors} /> */}
              {/* <HomeWidget displayText="API Calls" variableProp={APICalls} /> */}
              <HomeWidget displayText="New Active" asyncFunction={() => getNewDoctorsThisWeek("active")} helperScript={"active"} />
              <HomeWidget displayText="New Inactive" asyncFunction={() => getNewDoctorsThisWeek("inactive")} helperScript={"inactive"} />
            </div>
          </div>
          <div className="flex flex-col gap-3 mt-6">
            <h3 className="font-extrabold text-[24px]">Number of Doctors</h3>
            <h6>Date Range: {activeDoctorTimeline}</h6>
            <ActivityRateIncrease asyncFunction={getActiveVsTotal} />
            <div className="flex gap-4 flex-wrap w-[90%]">
              <LineGraph asyncFunction={getActiveVsTotal} />
            </div>
          </div>
          <div className="flex flex-col gap-3 mt-6">
            <h3 className="font-extrabold text-[24px]">Specialties</h3>
            <SpecialtyCount asyncFunction={getAllSpecialties} />
            <div className="flex gap-4 flex-wrap w-[90%]">
              <PieChartDisplay asyncFunction={getAllSpecialties} />
            </div>
          </div>
          <div className="flex flex-col gap-3 mt-6">
            <h3 className="font-extrabold text-[24px]">Organizations</h3>
            <div className="flex gap-4 flex-wrap w-[90%]">
              <OrgSelector asyncFunction={getAllOrgs} />
            </div>
          </div>
          <div className="flex flex-col gap-3 mt-2">
            <h3 className="font-extrabold text-[24px]">Doctors</h3>
            <div className="flex gap-4 flex-wrap w-[90%]">
              <DoctorSelector asyncFunction={queryAllDoctors} />
            </div>
          </div>
          <div className="flex flex-col gap-3 mt-2 pb-32">
            <h3 className="font-extrabold text-[24px]">Utilization</h3>
            <div className="flex gap-4 flex-wrap w-[90%]">
              <Utilization asyncFunction={getWeeklyDoctorUtilization} />
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};
